import React from "react";
import { motion } from "framer-motion";

const PrivacyPolicy = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#0B0F19] text-white min-h-screen font-sans selection:bg-cyan-500">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-black uppercase italic tracking-tighter mb-6 md:mb-8">
            Privacy <span className="text-cyan-400">Policy</span>
          </h1>

          <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-8 md:mb-12">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <div className="space-y-8 md:space-y-12">
            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                1. Information We Collect
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                We collect information you provide directly to us, such as when
                you create an account, fill out a contact form, or communicate
                with us. This may include your name, email address, phone
                number, and any other information you choose to provide.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                We also automatically collect certain information about your
                device and how you interact with our services, including IP
                address, browser type, device identifiers, and usage data.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                2. How We Use Your Information
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                We use the information we collect to provide, maintain, and
                improve our services, communicate with you about our products
                and services, and process transactions and send related
                information.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                We may also use your information to personalize your experience,
                analyze usage patterns, and develop new products and services.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                3. Information Sharing
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                We do not sell, trade, or rent your personal information to
                third parties. We may share your information with service
                providers who perform services on our behalf, such as hosting,
                data analysis, and customer support.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                We may also disclose information when required by law or to
                protect our rights, property, or safety, or that of our users or
                others.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                4. Data Security
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                We implement appropriate technical and organizational measures
                to protect your personal information against unauthorized
                access, alteration, disclosure, or destruction.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                However, no method of transmission over the internet or
                electronic storage is completely secure, and we cannot guarantee
                absolute security.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                5. Your Rights
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                You have the right to access, correct, or delete your personal
                information. You may also opt out of certain communications from
                us.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                To exercise these rights, please contact us using the
                information provided below.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                6. Contact Us
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                If you have any questions about this Privacy Policy, please
                contact us at:
              </p>
              <div className="space-y-2">
                <p className="text-cyan-400 text-sm md:text-base font-medium">
                  Email: support@cbs.com.mm
                </p>
                <p className="text-cyan-400 text-sm md:text-base font-medium">
                  Address: Connected Business Solutions, Yangon, Myanmar
                </p>
              </div>
            </motion.section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
